import qs from 'query-string';
import _ from 'lodash';
import {
  useCallback,
  useState,
} from 'react';



function getInitialStepperValue(steps, initialStep) {
    if (initialStep !== undefined && initialStep !== null && initialStep >= 0 && initialStep <= steps - 1) {
      return initialStep;
    }
    return 0;
  }
  

export function useStepper( config) {
    const { initialStep, steps } = config;
    const [step, setStep] = useState(getInitialStepperValue(steps, initialStep));
  
    const handleNext = useCallback(() => {
      if (step + 1 < steps) {
        setStep(step + 1);                                                                                   
      }
    }, [steps, step]);
  
    const handleBack = useCallback(() => {
      if (step - 1 >= 0) {
        setStep(step - 1);
      }
    }, [step]);
  
    const handleSetStep = useCallback(
      (newStep) => {
        if (!_.isNil(newStep) && newStep >= 0 && step <= steps) {
          setStep(newStep);
        }
      },
      [steps, step]
    );
    const data = {
        config,
        current: step,
      };
    
      return [data, handleNext, handleBack, handleSetStep ];
    }
    